import React from "react";
import style from "./style.module.css";
import { useSelector } from "react-redux";
import lang from "../../../../lang/lang";

const CompareNull = () => {
  const { currentLanguage } = useSelector(({ main }) => main);

  return (
    <div className={style.compare_null_block}>
      <div className={style.compare_null_content}>
        <div className={style.empty_compare_img}>
          <img
            src="https://vlv.am/public/img/empty_compare.svg"
            alt={lang[currentLanguage]?.COMPARE || "VLV"}
          />
        </div>
        <p>{lang[currentLanguage]?.compare_list_is_empty}</p>
      </div>
    </div>
  );
};

export default CompareNull;
